import { FC } from 'react'

import { useRouter } from 'next/navigation'

import { ExternalUserListRow } from 'src/components/organisms'

import { Routes } from 'src/routes'
import { SelectableExternalUserEntity } from 'src/types'

type Props = {
  externalUsers: SelectableExternalUserEntity[]
  onSelectUser: (user: SelectableExternalUserEntity) => void
  className?: string
}

export const ExternalUserListBody: FC<Props> = ({ externalUsers, onSelectUser, className }) => {
  const router = useRouter()

  return (
    <div className={className}>
      <div className="tw-border-t tw-border-t-border-secondary">
        {externalUsers.map(externalUser => (
          <div
            role="presentation"
            key={externalUser.id}
            className="tw-mb-8 last:tw-mb-0 tw-border-b last:tw-border-b-0 tw-border-b-border-secondary"
            onClick={() =>
              router.push(Routes.ExternalUserDetail.buildPath({ userId: externalUser.id }))
            }
          >
            <ExternalUserListRow externalUser={externalUser} onSelectUser={onSelectUser} />
          </div>
        ))}
      </div>
    </div>
  )
}
